import { useState } from 'react';
import { Form, Input, Button, Typography, App as AntdApp } from 'antd';
import { LockOutlined, MobileOutlined } from '@ant-design/icons';
import { useAuth } from './use-auth';
import { useNavigate } from 'react-router-dom';
import Logo from '../layouts/Logo';
import { BRAND_PRIMARY, HAIRLINE } from '../theme';

const { Title, Text } = Typography;

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [loading, setLoading] = useState(false);
  const { message } = AntdApp.useApp();

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        background:
          'radial-gradient(1200px 600px at 50% -10%, rgba(0,185,107,0.08), transparent 60%), #F6F8FA',
      }}
    >
      <div
        style={{
          width: 400,
          maxWidth: '100%',
          background: '#FFFFFF',
          border: `1px solid ${HAIRLINE}`,
          borderRadius: 16,
          boxShadow:
            '0 1px 2px rgba(15,23,42,0.04), 0 12px 32px rgba(15,23,42,0.06)',
          padding: '32px 32px 28px',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            marginBottom: 4,
          }}
        >
          <Logo size={28} />
          <span
            style={{
              fontSize: 17,
              fontWeight: 600,
              letterSpacing: -0.01,
              color: '#0F172A',
            }}
          >
            AlphaStep
          </span>
        </div>
        <Title
          level={4}
          style={{
            margin: '12px 0 4px',
            fontSize: 20,
            fontWeight: 600,
            letterSpacing: -0.01,
          }}
        >
          欢迎回来
        </Title>
        <Text type="secondary" style={{ fontSize: 13 }}>
          登录以管理门店、课程与学员。
        </Text>

        <div style={{ height: 24 }} />

        <Form
          layout="vertical"
          requiredMark={false}
          size="large"
          onFinish={async (v: { phone: string; password: string }) => {
            setLoading(true);
            try {
              await login(v.phone, v.password);
              nav('/');
            } catch (e) {
              message.error((e as Error).message);
            } finally {
              setLoading(false);
            }
          }}
        >
          <Form.Item
            name="phone"
            label="手机号 / 登录账号"
            rules={[{ required: true, message: '请输入 8-15 位手机号 / 登录账号', min: 8, max: 15 }]}
          >
            <Input
              prefix={<MobileOutlined style={{ color: '#94A3B8' }} />}
              placeholder="手机号 / 登录账号"
              autoComplete="username"
              inputMode="numeric"
              maxLength={15}
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="密码"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: '#94A3B8' }} />}
              placeholder="请输入密码"
              autoComplete="current-password"
            />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            block
            size="large"
            loading={loading}
            style={{ marginTop: 4, fontWeight: 500 }}
          >
            登录
          </Button>
        </Form>

        <div
          style={{
            marginTop: 24,
            paddingTop: 16,
            borderTop: `1px solid ${HAIRLINE}`,
            fontSize: 12,
            color: '#94A3B8',
            textAlign: 'center',
          }}
        >
          仅限授权工作人员使用 ·{' '}
          <span style={{ color: BRAND_PRIMARY, fontWeight: 500 }}>AlphaStep</span>
        </div>
      </div>
    </div>
  );
}
